import { defineMessages, type MessageDescriptor } from 'react-intl';

const messages: Record<'defaultRovoName', MessageDescriptor> = defineMessages({
	defaultRovoName: {
		id: 'conversation-assistant.chat-history.store-assistant.agent-response-hat-messages.defaultRovoName',
		defaultMessage: 'Rovo',
		description:
			'Display name shown next to the Rovo logo in the agent attribution hat above an assistant message. Used when the default Rovo agent (no specialist agent) responded.',
	},
});

export default messages;
